import { FC, useContext, useEffect, useMemo } from "react";

import { LoaderContext } from "context/GlobalLoader";

import { CompanyItem } from "entities/companies";
import { DateHelper } from "utils/helpers";

import styles from "./style.module.scss";

type PropTypes = {
  company: CompanyItem | null;
};

const CompanyOverviewTab: FC<PropTypes> = ({ company }) => {
  const { handleLoad } = useContext(LoaderContext);

  const companyInformation = useMemo(
    () => [
      { name: "Company name", value: company?.name || "-" },
      { name: "Emirate", value: company?.city?.label || "-" },
      { name: "Created Date", value: DateHelper.toFormat(company?.created_at, "MMMM dd, yyyy") || "-" },
    ],
    [company],
  );

  const companyOwner = useMemo(
    () => [
      { name: "Name", value: company?.owner?.full_name || "-" },
      { name: "Position", value: company?.owner?.position || "-" },
      { name: "Email", value: company?.owner?.email || "-" },
      { name: "Phone", value: company?.owner?.phone || "-" },
    ],
    [company],
  );

  useEffect(() => {
    handleLoad(true);

    setTimeout(() => {
      handleLoad(false);
    }, 1000);
  }, []);

  return (
    <div className={styles.overview}>
      <div className={styles.companyData}>
        <p className={styles.companyDataTitle}>Company information</p>

        <div className={styles.companyDataItems}>
          {companyInformation.map((item) => (
            <div key={item.name} className={styles.companyDataItem}>
              <p className={styles.companyDataItemName}>{item.name}</p>
              <p className={styles.companyDataItemValue}>{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.companyData}>
        <p className={styles.companyDataTitle}>Company owner</p>

        <div className={styles.companyDataItems}>
          {companyOwner.map((item) => (
            <div key={item.name} className={styles.companyDataItem}>
              <p className={styles.companyDataItemName}>{item.name}</p>
              <p className={styles.companyDataItemValue}>{item.value}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompanyOverviewTab;
